module.exports = __webpack_public_path__ + "1f97960ec6210effbb8ee3c7ecbe679b.pdf";